import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MmDialogService, MmDialogSize, MmMenuTrigger } from '@metromarkets/components';
import { Store } from '@ngrx/store';
import isEmpty from 'lodash.isempty';
import { filter, take } from 'rxjs/operators';
import { OrderActionsVisibility } from '../../classes/order-actions-visibility';
import { BuyerType } from '~shared/constants';
import { OrderHistoryItem } from '../../models';
import { OrderHistoryDialogConfigService } from '../../services/order-history-dialog-config.service';
import { cancelOrder, cancelReturnOrder, OrdersHistoryState, returnOrder } from '../../store/orders-history-list';
import { OrderConfirmDialogComponent } from '../order-confirm-dialog/order-confirm-dialog.component';
import { ReturnProductsDialogComponent } from '../returns/return-products-dialog/return-products-dialog.component';
import {
  DownloadInvoicesDialogComponent,
} from '../download-invoices-dialog/download-invoices-dialog.component';
import { DocumentsGroupUtils } from '../../utils';
import { ReceiveDocumentGetLink } from '../../store/receive-document-link';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { OrderHistoryApplicationEvent } from '~shared/modules/application-event/models';
import { GaTrackingEventName, GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';
import { OrderHistoryEventActionType } from '~shared/modules/application-event/constants';
import { OrderHistoryGaTrackingService } from '../../services/order-history-ga-tracking.service';
import { ACCORDIAN_COLLAPS, ACCORDIAN_EXPAND } from '../../constants';
@Component({
  selector: 'app-order-history-list-item',
  templateUrl: './order-history-list-item.component.html',
  styleUrls: ['./order-history-list-item.component.scss'],
  providers: [OrderHistoryDialogConfigService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderHistoryListItemComponent extends OrderActionsVisibility {
  @Input() order: OrderHistoryItem;
  @Input() isFirstOrder: boolean;
  @Input() isLastOrder: boolean;

  @Input() isContactEmailFeatureEnabled: boolean;
  @Input() isGetInvoiceFeatureEnabled: boolean;
  @Input() isMobileOrTablet: boolean;
  @Input() isEnabledPaymentMethodCode: boolean;
  @Input() isBuyAgainButtonEnable: boolean;
  @Input() isSubsidiaryAccount: boolean;
  public readonly buyerType = BuyerType;
  public readonly menuTrigger = MmMenuTrigger;

  constructor(private store$: Store<OrdersHistoryState>,
              private mmDialogService: MmDialogService,
              private dialogConfigSrv: OrderHistoryDialogConfigService,
              private applicationEventService: ApplicationEventService,
              private orderHistoryGaTrackingService: OrderHistoryGaTrackingService,
  ) {
    super();
  }

  public cancelOrder(): void {
    const dialogConfig = this.dialogConfigSrv.getCancelOrderConfig(this.order.orderNumber);

    this.mmDialogService
      .open(OrderConfirmDialogComponent, dialogConfig)
      .afterClosed()
      .pipe(take(1), filter(Boolean))
      .subscribe(() => {
        this.store$.dispatch(cancelOrder({ orderId: this.order.orderId }));

        this.applicationEventService.publish(new OrderHistoryApplicationEvent({
          event: GaTrackingEventName.CancelOrder,
          action: OrderHistoryEventActionType.CancelOrder,
          label: GaTrackingEventLabel.OrderHistoryClick,
        }));
      });
  }


  public returnOrder(): void {
    const dialogConfig = this.dialogConfigSrv.getReturnOrderConfig(this.order.orderNumber, this.order);

    this.mmDialogService.open(ReturnProductsDialogComponent, dialogConfig)
      .afterClosed()
      .pipe(
        filter((data) => !isEmpty(data)),
        take(1),
      ).subscribe(({reason}) => {
      const payload = {
        orderId: this.order.orderId,
        orderLineIds: this.order.orderLines
          .filter(orderLine => orderLine.allowedTransitions.requestReturn)
          .map(({orderLineId}) => orderLineId),
        returnReason: reason
      };
      return this.store$.dispatch(returnOrder(payload));
    });
  }

  public cancelReturnOrder() {
    const dialogConfig = this.dialogConfigSrv.cancelReturningConfig;

    this.mmDialogService.open(OrderConfirmDialogComponent, dialogConfig)
      .afterClosed()
      .pipe(
        filter(Boolean),
        take(1),
      ).subscribe(() => this.store$.dispatch(cancelReturnOrder({ orderId: this.order.orderId, orderLineIds: this.order.orderLines.map(({orderLineId}) => orderLineId) })));
  }

  public downloadInvoices(): void {
    this.sendGAEventDownloadInvoices();

    const { documents, isCreditNotesVisible } = DocumentsGroupUtils
      .mapDocuments(this.order.orderLines);

    const isOneUniqInvoiceAttached = (documents.length === 1) &&
      (documents[0].invoices.length === 1) &&
      (!documents[0].creditNotes.length);

    if (isOneUniqInvoiceAttached) {
      const { invoices } = documents[0];
      const [invoiceGroupedArray] = invoices;
      const [document] = invoiceGroupedArray;
      const { id, name, type } = document;
      this.store$.dispatch(new ReceiveDocumentGetLink({ id, name, type }));
    } else {
      const dialogConfig = {
        dialogSize: MmDialogSize.fit,
        width: '800px',
        autoFocus: false,
        data: {
          orderNumber: this.order.orderNumber,
          documents,
          isCreditNotesVisible,
        },
      };

      this.mmDialogService.open(DownloadInvoicesDialogComponent, dialogConfig);
    }
  }
  public sendGAEventPaymentShiptment(isExpanded: boolean) : void {
    this.orderHistoryGaTrackingService.gaTrackingOrderHisotryInteractionsEvent
    (GaTrackingEventName.OrderHistoryInteraction,OrderHistoryEventActionType.PaymentShipmentInfo,
      isExpanded? ACCORDIAN_EXPAND:ACCORDIAN_COLLAPS);
  }

  private sendGAEventDownloadInvoices() : void {
    this.orderHistoryGaTrackingService.gaTrackingOrderHisotryInteractionsEvent
    (GaTrackingEventName.OrderHistoryInteraction,OrderHistoryEventActionType.GetInvoiceButton,
    '');
  }
}
